export default __webpack_public_path__ + "static/media/piper-tilden.9656bc18.jpg";